/**
 * Geography API Service
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";
import type {
  GeographicHierarchiesResponse,
  GeographicHierarchyItem,
  GeographicNodesResponse,
  GeographicNodesParams,
  GeographicNodeWithGeometry,
} from "../types";

export const geographicHierarchiesApi = {
  /**
   * Get all geographic hierarchies available for the organization
   * The organization is determined by the 'org-name' header set by the API client
   */
  list: async (): Promise<GeographicHierarchyItem[]> => {
    const response = await api.get<GeographicHierarchiesResponse>(
      ENDPOINTS.GEO_HIERARCHIES,
    );
    return response.items;
  },
};

export const geographicNodesApi = {
  /**
   * Get geographic nodes with geometry for map display
   *
   * @param params.resolution - Resolution level (e.g., "Operating Company", "District")
   * @param params.id - Comma-separated list of node IDs
   * @returns Array of geographic nodes with geometry
   */
  list: async (
    params: GeographicNodesParams,
  ): Promise<GeographicNodeWithGeometry[]> => {
    const response = await api.get<GeographicNodesResponse>(
      ENDPOINTS.GEO_NODES,
      {
        params: {
          resolution: params.resolution,
          id: params.id,
          ...(params.geo_version !== undefined && { geo_version: params.geo_version }),
        },
      },
    );
    return response.data;
  },
};

export default geographicHierarchiesApi;
